const API_ROUTE = process.env.VUE_APP_API_ROUTE

// Auth token
const GET_LOGIN_WORKSTATION_USER_TOKEN = API_ROUTE + '/auth/get_access_token_g_pos_workstation_user'

export default {
    GET_LOGIN_WORKSTATION_USER_TOKEN,
}